const SALES_PLAN_PRODUCT_TYPE_LABEL_KEYS = {
  hybrid: "sales_plans.product_types.type_i",
  x: "sales_plans.product_types.type_i",
  cash: "sales_plans.product_types.type_ii",
  deposit_goods: "sales_plans.product_types.type_ii",
  harvest: "sales_plans.product_types.type_ii",
  frs: "sales_plans.product_types.type_ii",
  km: "sales_plans.product_types.type_ii",
  jp: "sales_plans.product_types.type_ii",
};

export function salesPlanDisplayLabel(salesPlan) {
  if (!salesPlan || typeof salesPlan !== "object") {
    return "-";
  }

  const id = salesPlan.id ?? "-";
  const productName = salesPlan?.product?.name ?? "-";

  return `${id}: ${productName}`;
}

export function salesPlanDisplayName(salesPlan) {
  if (!salesPlan || typeof salesPlan !== "object") {
    return "-";
  }

  return salesPlan.name || salesPlan.id || "-";
}

export function salesPlanProductTypeLabel(salesPlan, t = (key) => key) {
  if (!salesPlan || typeof salesPlan !== "object") {
    return null;
  }

  const productCode = String(salesPlan?.product_type ?? salesPlan?.product?.code ?? "").toLowerCase();
  const labelKey = SALES_PLAN_PRODUCT_TYPE_LABEL_KEYS[productCode];

  if (!labelKey || typeof t !== "function") {
    return null;
  }

  return t(labelKey);
}

export function salesPlanDisplayIdLabel(salesPlan, t = (key) => key) {
  if (!salesPlan || typeof salesPlan !== "object") {
    return "-";
  }

  const id = salesPlan.id ?? "-";
  const productTypeLabel = salesPlanProductTypeLabel(salesPlan, t);

  if (!productTypeLabel) {
    return `${id}`;
  }

  return `${id}: ${productTypeLabel}`;
}

export function hasTicket(model) {
  return !!(model?.ticket && Object.keys(model.ticket).length > 0);
}

export function ticketOrPurchasePlanDisplayValue(model, t = (key) => key) {
  const ticket = model?.ticket;
  if (hasTicket(model)) {
    return `${ticket.id}: ${t(`tickets.customer_types.${ticket.customer_type}`)}`;
  }

  const salesPlan = model?.purchase_plan?.sales_plan;
  if (salesPlan) {
    return salesPlanDisplayName(salesPlan);
  }

  return "-";
}

export function salesPlanSelectLabel(salesPlan) {
  if (!salesPlan) {
    return "";
  }

  return salesPlan.name
    ? `${salesPlan.name}`
    : `${salesPlan.id} - ${salesPlan.product?.name ?? "-"} - ${salesPlan.partner?.name ?? "-"}`;
}
